module.exports = __webpack_public_path__ + "805e64e5744d7b0a4d3927e5feabbb34.jpg";